import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { MerchantOverviewPlazamapPage } from './merchant-overview-plazamap';

@NgModule({
  declarations: [
    MerchantOverviewPlazamapPage,
  ],
  imports: [
    IonicPageModule.forChild(MerchantOverviewPlazamapPage),
    TranslateModule.forChild()
  ],
})
export class MerchantOverviewPlazamapPageModule {}



// WEBPACK FOOTER //
// ./src/pages/merchant-overview-plazamap/merchant-overview-plazamap.module.ts